module.exports = __webpack_public_path__ + "img/day-without-hate.288dcce7.png";